import React from 'react';

import styled from '@emotion/styled';

import { COLORS, FontWeight, Text, TextButton, transparentize } from '@clutter/clean';

import { TextButton as ProtectedTextButton } from '@portal/components/shared//customer_protected/text_button';
import { TrackedClick } from '@portal/components/wt/tracked_click';
import { IEventParams } from '@portal/types/wt/event';

/** Shared with other inventory alerts (e.g. pre-existing condition notes banner) for consistent type scale. */
export const DetailedBannerAlertContainer = styled.div`
  position: relative;
  background: ${transparentize(COLORS.flower, 0.4)};
  border-radius: 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  button {
    color: ${COLORS.toucan};
    &:hover {
      color: ${transparentize(COLORS.toucan, 0.8)};
    }
  }
  margin-bottom: 32px;
`;

export const DetailedBannerAlertHeading = styled(Text.Callout)`
  margin-bottom: 4px;
`;

export const DetailedBannerAlertSubheading = styled(Text.Caption)`
  margin-bottom: 24px;
`;

export const DetailedBannerAlert: React.FC<{
  handleClick(event: React.MouseEvent<HTMLButtonElement>): void;
  heading: string;
  subheading: string;
  linkText: string;
  trackingParams?: IEventParams;
  customerProtected?: boolean;
}> = ({ handleClick, heading, subheading, linkText, trackingParams, customerProtected = false }) => {
  const Button = customerProtected ? ProtectedTextButton : TextButton;
  const actionButton = <Button onClick={handleClick}>{linkText}</Button>;
  const trackedActionButton = trackingParams && <TrackedClick params={trackingParams}>{actionButton}</TrackedClick>;

  return (
    <>
      <DetailedBannerAlertContainer>
        <DetailedBannerAlertHeading weight={FontWeight.Medium}>{heading}</DetailedBannerAlertHeading>
        <DetailedBannerAlertSubheading>{subheading}</DetailedBannerAlertSubheading>
        {trackedActionButton || actionButton}
      </DetailedBannerAlertContainer>
    </>
  );
};
